<template>
  <div class="pjmain">
    <div class="content" v-cloak>
      <div class="pjxqtitle">
        <div class="sm-tit" style="margin-bottom: 10px">缴费信息</div>
        <p><span>业主姓名：</span>{{ jfxq.ownershipName||'暂无' }}</p>
        <p><span>小区名称：</span>{{ jfxq.villageName }}</p>
        <p><span>楼栋号：</span>{{ jfxq.no }}栋</p>
        <p><span>单元：</span>{{ jfxq.unitNum || "暂无" }}</p>
        <p><span>楼层：</span>{{ jfxq.floorNum }}</p>
        <p><span>门牌号：</span>{{ jfxq.ucAddress }}</p>
        <p><span>面积：</span>{{ jfxq.area }}</p>
        <p><span>缴费开始时间：</span>{{ jfxq.startMonth }}</p>
        <p><span>缴费结束时间：</span>{{ jfxq.endMonth }}</p>
        <!-- <p><span>物业费：</span>{{ jfxq.lstaccrbal }}</p>
            <p><span>公共能耗：</span>{{ jfxq.publicEnergy }}</p>
            <p><span>电梯费：</span>{{ jfxq.elevatorFee }}</p>
            <p><span>停车费：</span>{{ jfxq.parkingFee }}</p>
            <p><span>应该缴总金额：</span>{{ jfxq.propertyFee }}</p>
            <p><span>备注：</span>{{ jfxq.bz }}</p> -->
          <div v-show="type=='1'">
        <p><span>物业服务费：</span>{{ jfxq.propertyFee }}&nbsp;&nbsp;元</p>
        <p>
          <span>产权车位管理费：</span
          >{{ jfxq.parkingManageFee || "0" }}&nbsp;&nbsp;元
        </p>
          </div>



          <div v-show="type=='2'">
                    <p>
          <span>公共水电费：</span>{{ jfxq.publicWater || "0" }}&nbsp;&nbsp;元
        </p>
        <!-- <p>
          <span>公共电费：</span
          >{{ jfxq.publicElectricity || "0" }}&nbsp;&nbsp;元
        </p> -->
        <p>
          <span>电梯运行电费：</span>{{ jfxq.elevatorFee || "0" }}&nbsp;&nbsp;元
        </p>
        <p>
          <span>电梯维护费：</span
          >{{ jfxq.maintenanceFee || "0" }}&nbsp;&nbsp;元
        </p>
        <p><span>电梯年检费：</span>{{ jfxq.checkFee || "0" }}&nbsp;&nbsp;元</p>
          </div>


      <div v-show="type=='3'">
        <p>
          <span>地上车位停放费：</span>{{ jfxq.parkingRentalFee || "0" }}&nbsp;&nbsp;元
        </p>
        <p><span>人防汽车停放费：</span>{{ jfxq.underParkingFee || "0" }}&nbsp;&nbsp;元</p>
      </div>

      <div v-show="type=='5'">
        <p><span>人防车位费：</span>{{ jfxq.defenseParkingFee || "0" }}&nbsp;&nbsp;元</p>
      </div>







        <!-- <p>
          <span>应缴总金额：</span>{{ jfxq.total || "0" }}&nbsp;&nbsp;元
        </p> -->

        <p>
          <span>优惠：</span>{{ jfxq.per || "0" }}
        </p>
        <p>
          <span>应缴金额：</span>{{ jfxq.amount || "0" }}&nbsp;&nbsp;元
        </p>
        <p>
          <span>实缴金额：</span>{{ jfxq.actually || "0" }}&nbsp;&nbsp;元
        </p>
        <p><span>备注：</span>{{ jfxq.bz }}</p>
      </div>

      <div class="sm-tit" v-if="jfxq.isPay !== '已缴'">
        <div class="bt md20">
          <button @click="jf()" class="btn">缴费</button>
        </div>

                <div class="bt md20">
          <button @click="show = true" class="btn btn1">分享账单</button>
        </div>

        <van-overlay :show="show" @click="show = false">
          <img src="../../assets/share.png" alt="" class="share">
        </van-overlay>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import wx from "weixin-js-sdk";
import { Image as VanImage, ImagePreview, Tab, Tabs, Step, Steps } from "vant";

Vue.use(VanImage);
Vue.use(ImagePreview);
Vue.use(Step);
Vue.use(Steps);
export default {
  data() {
    return {
      lcno: 0,
      tsxq: {},
      jfxq: {},
      show:false,
      trueName:'',
      type:"",
    };
  },
  
  mounted() {
    var id = this.$route.query.id;
    this.type = this.$route.query.type;
    var that=this
        if(that.$route.query.typeName){
          
          that.$emit('fatherMethod',{
            title:that.$route.query.typeName
           })
        }
    this.$axios
      .get("/api/v1/wygl/propertyPayment/viewOne?id=" + id+"&type="+this.type)
      .then((res) => {
        that.jfxq = res;
      that.getShareInfo(); // 调用分享的事件
      });
  },
  methods: {
        getShareInfo() {
      var that = this;
      var jsonData = {
        id: that.$route.query.id,
        totalFee: that.jfxq.actually,
        validTime: "10000",
        backUrl:
          "https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/index.html#/wyfw/jflist",
        proInfo: that.$route.query.typeName,
        attach: "",
        shopId: that.jfxq.villageId,
        operatorId: "",
        outTradeNo: that.$route.query.id,
        extf1d1: "",
        extf1d2: "",
        extf1d3: "",
        type: that.$route.query.type,
      };
      console.log("🚀 ~ file: jfdetail.vue:154 ~ getShareInfo ~ jsonData:", jsonData)

      var jsonString = encodeURIComponent(JSON.stringify(jsonData));
      console.log("🚀 ~ file: jfdetail.vue:155 ~ getShareInfo ~ jsonString:", jsonString)

      this.$axios
        .get("https://zhwy.zjj.suqian.gov.cn/api/wechat/wxConfig", {
          params: {
            url: window.location.href.split("#")[0],
          },
        })
        .then(function (res) {
          const data = res;
          wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ["onMenuShareAppMessage", "updateAppMessageShareData"],
          });
          wx.ready(() => {
            var shareData = {
              title: that.jfxq.villageName+"业主缴费单分享",
              desc: "缴费单分享链接",
              link: `https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/ercode/jfd.html?params=${jsonString}`,
              imgUrl:
                "https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/ercode/img/logo23.png",
            };
            wx.onMenuShareAppMessage(shareData);
            wx.updateAppMessageShareData(shareData);
          });

          wx.error((res) => {
            console.log(res);
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    jf() {

      var that=this



      let data = new FormData();
      var jsonData={
            id:that.$route.query.id,
            totalFee:that.jfxq.actually,
            validTime:'10000',
            backUrl:'https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/index.html#/wyfw/jflist',
            proInfo:that.$route.query.typeName,
            attach:'',
            shopId:that.jfxq.villageId,
            operatorId:'',
            outTradeNo:that.$route.query.id,
            extf1d1:'',
            extf1d2:'',
            extf1d3:'',
            type:that.$route.query.type
				}

      for(let key in jsonData) {
        data.append(key,jsonData[key]);
      }
      this.$axios
        .post("/api/v1/jSbank/atPay", data)
        .then(res=> {
          // debugger
          if(res.payUrl){ 
            window.location.href = res.payUrl;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.bt {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.md20 {
  margin-bottom: 20px;
}
.pjmain {
  height: calc(100% - 46px);
  width: 100%;
  background-color: #fff;
}
.shangchuan {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  border-bottom: #f4f4f4 1px solid;
  font-size: 16px;
}
.pj-dv {
  // border-top: 1px solid #f4f4f4;
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.sm-tit {
  color: #28aff6;
}
.btn {
  margin-top: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white !important;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  width: 70%;
  cursor: pointer;
}
.content {
  height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
  .pjxqtitle {
    padding: 10px 0;
    font-size: 18px;
    border-bottom: #f4f4f4 1px solid;
    p {
      margin: 5px auto;
      span {
        display: inline-block;
        color: #999999;
        width: 140px;
        text-align: right;
      }
      font-size: 14px;
      color: #000;
      // margin: 0;
      line-height: 2rem;
    }
  }
  .bxqk {
    width: 100%;
    line-height: 25px;
    textarea {
      height: 125px;
      outline: none;
      border: #dddddd 1px solid;
      border-radius: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-indent: 2rem;
      color: #999999;
    }
    p {
      margin: 0;
      padding: 0;
    }
  }
}
.daxing {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
  }
}
.tijiao {
  margin-top: 30px;
  margin-bottom: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  margin-left: 15%;
  width: 70%;
  cursor: pointer;
}
.dpj {
  height: 25px;
  top: calc(50% - 15px);
  border: 1px solid #00d2ff;
  color: #00d2ff;
  background-color: transparent;
  border-radius: 30px;
  font-size: 15px;
}
.btn1{
  background: #e2c937;
}
.share{
position: absolute;
  right: 0px;
}
</style>
